import { defineComponent as _defineComponent } from 'vue'
import { Typo, Icon } from '@travelata-libs/ui-kit';
    import { ref, computed, nextTick, defineComponent, h } from 'vue';
    import SelectInput from '@ve/components/inputs/SelectInput.vue';
    import { useTouristGroupModel } from '@entities/searchCriteria/touristGroup';
    import { Dropdown, Counter } from '@shared/ui';
    import isMobileVersion from '@/js/common/Service/isMobileVersion';
    import { kidsAgesOption } from '../config/selectTouristGroupConfig';

    type Age = number | null;

    
export default /*#__PURE__*/_defineComponent({
  __name: 'TouristGroupSelector',
  props: {
    modelPrefix: null
  },
  setup(__props: any) {

const props = __props as { modelPrefix: string }

    const INFANT_MAX_AGE = 1;
    const KIDS_MAX_AMOUNT = 3;
    const MAX_ROOMS_AMOUNT = 7;
    
    const listContainer = ref<HTMLElement | null>(null);
    const { updateTouristGroup, touristGroup } = useTouristGroupModel(props.modelPrefix);
    const isMobile = !!isMobileVersion();
    const normalizeAges = (ages: Age[]): Age[] => (ages.length === 0 ? [null] : ages);
    const getKidsGroup = (ages: number[]) => ({
        kids: ages.filter(age => age > INFANT_MAX_AGE).length,
        infants: ages.filter(age => age <= INFANT_MAX_AGE).length
    });

    const getVisibleKidFields = (ages: Age[]): Age[] => {
        const result = [...ages];
  
        if (result.length < KIDS_MAX_AMOUNT && result.every(age => age !== null)) {
            result.push(null);
        }
        return result.slice(0, KIDS_MAX_AMOUNT); // Ограничиваем максимум 3 детей
    };
    /**
     * Преобразование "сырой" структуры touristGroup в массив комнат с нормализованными ages.
     * Нулевая комната – (основная), остальные – из touristsByRooms.
     */
    const roomsComputed = computed(() => {
        const result = [{
            adults: touristGroup.value.adults,
            kids: touristGroup.value.kids,
            infants: touristGroup.value.infants,
            ages: normalizeAges(touristGroup.value.ages),
        }];

        if (touristGroup.value.touristsByRooms?.length > 0) {
            touristGroup.value.touristsByRooms.forEach((rawTouristsAtRoom) => {
                const touristsAtRoom = {
                    adults: rawTouristsAtRoom.adults,
                    kids: rawTouristsAtRoom.kids,
                    infants: rawTouristsAtRoom.infants,
                    ages: normalizeAges(rawTouristsAtRoom.ages),
                }

                result.push(touristsAtRoom);
            });
        }

        return result;
    });

    const mobileContainer = defineComponent({
        setup(_, { slots }) {
            return () => {
                return h('div', [slots.content ? slots.content() : h('')])
            }
        }
    });

    const updateRoomByIndex = (index: number, updater: (room: any) => any) => {
        if (index === 0) {
            const updatedMain = updater(touristGroup.value);

            updateTouristGroup({
                ...touristGroup.value,
                ...updatedMain,
            });
            return;
        }

        const roomIdx = index - 1;
        const updatedRooms = touristGroup.value.touristsByRooms.map((room: any, i: number) =>
            i === roomIdx ? updater(room) : room,
        );

        updateTouristGroup({
            ...touristGroup.value,
            touristsByRooms: updatedRooms,
        });
    };

    const onUpdateCounterAdult = (value: number, index: number) => {
        updateRoomByIndex(index, room => ({
            ...room,
            adults: value,
        }));
    };

    const onAddRoom = () => {
        const newRoom = {
            adults: 2,
            kids: 0,
            infants: 0,
            ages: [] as number[],
        };

        const touristsByRooms = [...touristGroup.value.touristsByRooms, newRoom];

        updateTouristGroup({
            ...touristGroup.value,
            touristsByRooms,
        });

        nextTick(() => {
            if (!listContainer.value) return;

            listContainer.value.scrollTo({
                behavior: 'smooth',
                top: listContainer.value.scrollHeight,
            });
        });
    };

    const onRemoveRoom = (index: number) => {
        const touristsByRooms = touristGroup.value.touristsByRooms.filter((_, i) => i !== index);

        updateTouristGroup({
            ...touristGroup.value,
            touristsByRooms,
        });
    };

    const onSetKids = (rawAge: number | string, roomIndex: number, kidsIndex: number) => {
        const age = typeof rawAge === 'string' ? Number(rawAge) : rawAge;

        updateRoomByIndex(roomIndex, room => {
            const prevAges = room.ages as number[];
            const newAges = [...prevAges];

            if (newAges.length === kidsIndex) {
                newAges.push(age);
            } else {
                newAges[kidsIndex] = age;
            }

            const kidsGroup = getKidsGroup(newAges);

            return {
                ...room,
                ...kidsGroup,
                ages: newAges,
            };
        });
    };

    const onRemoveKid = (roomIndex: number, kidsIndex: number) => {
        updateRoomByIndex(roomIndex, room => {
            const newAges = (room.ages as number[]).filter((_, index) => index !== kidsIndex);
            const kidsGroup = getKidsGroup(newAges);

            return {
                ...room,
                ...kidsGroup,
                ages: newAges,
            };
        });
    };

return { __sfc: true,INFANT_MAX_AGE, KIDS_MAX_AMOUNT, MAX_ROOMS_AMOUNT, props, listContainer, updateTouristGroup, touristGroup, isMobile, normalizeAges, getKidsGroup, getVisibleKidFields, roomsComputed, mobileContainer, updateRoomByIndex, onUpdateCounterAdult, onAddRoom, onRemoveRoom, onSetKids, onRemoveKid, Typo, Icon, SelectInput, Dropdown, Counter, kidsAgesOption }
}

})